import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {BehaviorSubject, Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PersonsService {
  initialValue: boolean = false;
  refreshPersonSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.initialValue);

  constructor(private http: HttpClient, private router: Router) { }


  toggleRefreshData() {
    this.refreshPersonSource.next(!this.refreshPersonSource.value)
  }

  getRefreshData(): Observable<boolean> {
    return this.refreshPersonSource.asObservable();
  }

  getPersonsFilter(body: any, version = ""): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api${version}/persons/etablissements/search`, body);
  }

  deletePerson(id: any): Observable<any> {
    return this.http.delete(`${environment.api.BASE_URL}/api/persons/${id}`, {responseType: 'text'});
  }

  addPerson(body: any, id: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/persons/etablissements/${id}`, body);
  }
}
